import React from 'react';
import { getDirectionIcon } from '../../utils/geocoding';

const RouteAnalysisModal = ({ route, instructions, loading, directionsError, onClose }) => {
  if (!route) return null;

  return (
    <div onClick={onClose} style={{ display: 'block', position: 'fixed', zIndex: 1000, left: 0, top: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', overflow: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'white', margin: '2% auto', borderRadius: '16px', width: '95%', maxWidth: '1200px', maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '25px 30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: '24px', fontWeight: 700, margin: 0, marginBottom: '8px' }}>📊 Detailed Route Analysis</h2>
              <p style={{ fontSize: '14px', margin: 0, opacity: 0.9 }}>{route.vehicle.name} - {route.vehicle.driver}</p>
            </div>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', fontSize: '28px', width: '45px', height: '45px', borderRadius: '50%', cursor: 'pointer' }}>×</button>
          </div>
        </div>

        <div style={{ flex: 1, overflow: 'auto', padding: '30px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '30px' }}>
            {[
              { icon: '📍', label: 'Total Distance', value: `${route.totalDistance} km`, color: '#667eea' },
              { icon: '⏱️', label: 'Estimated Time', value: `${Math.floor(route.totalTime)} hrs ${Math.round((route.totalTime % 1) * 60)} mins`, color: '#10b981' },
              { icon: '💰', label: 'Fuel Cost', value: `₹${route.totalCost}`, color: '#f59e0b' },
              { icon: '📦', label: 'Total Stops', value: route.deliveries.length, color: '#ef4444' },
              { icon: '⚖️', label: 'Total Load', value: `${route.totalWeight}kg`, color: '#8b5cf6' },
              { icon: '🚚', label: 'Capacity Used', value: `${Math.round((route.totalWeight / route.vehicle.capacity) * 100)}%`, color: '#ec4899' }
            ].map((stat, idx) => (
              <div key={idx} style={{ background: 'white', border: '2px solid #f3f4f6', borderRadius: '12px', padding: '20px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>{stat.icon}</div>
                <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '5px' }}>{stat.label}</div>
                <div style={{ fontSize: '22px', fontWeight: 700, color: stat.color }}>{stat.value}</div>
              </div>
            ))}
          </div>

          <div style={{ background: 'white', border: '2px solid #f3f4f6', borderRadius: '12px', padding: '25px', marginBottom: '25px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', marginBottom: '20px' }}>🗺️ Complete Route Sequence</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ minWidth: '60px', height: '60px', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '24px' }}>🏭</div>
                <div style={{ flex: 1, background: '#f0fdf4', border: '2px solid #86efac', borderRadius: '10px', padding: '15px' }}>
                  <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>Starting Point - Depot</div>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>📍 {route.vehicle.location}</div>
                  <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '5px' }}>🌐 {route.vehicle.coords[1].toFixed(6)}, {route.vehicle.coords[0].toFixed(6)}</div>
                </div>
              </div>
              <div style={{ marginLeft: '30px', fontSize: '24px', color: '#9ca3af' }}>↓</div>
              {route.deliveries.map((delivery, idx) => (
                <React.Fragment key={idx}>
                  <div style={{ display: 'flex', gap: '15px' }}>
                    <div style={{
                      minWidth: '60px', height: '60px',
                      background: delivery.priority === 'high' ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' :
                                 delivery.priority === 'medium' ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' :
                                 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                      borderRadius: '12px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white'
                    }}>
                      <div style={{ fontSize: '20px' }}>📦</div>
                      <div style={{ fontSize: '11px', fontWeight: 600 }}>Stop {idx + 1}</div>
                    </div>
                    <div style={{ flex: 1, background: 'white', border: '2px solid #e5e7eb', borderRadius: '10px', padding: '15px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>{delivery.name}</div>
                        <span style={{
                          padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 600,
                          background: delivery.priority === 'high' ? '#fee2e2' : delivery.priority === 'medium' ? '#fef3c7' : '#dbeafe',
                          color: delivery.priority === 'high' ? '#991b1b' : delivery.priority === 'medium' ? '#92400e' : '#1e40af'
                        }}>
                          {delivery.priority.toUpperCase()}
                        </span>
                      </div>
                      <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>📍 {delivery.location}</div>
                      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '5px' }}>⚖️ {delivery.weight}kg | ⏰ {delivery.timeWindow.start}:00 - {delivery.timeWindow.end}:00</div>
                    </div>
                  </div>
                  {idx < route.deliveries.length - 1 && <div style={{ marginLeft: '30px', fontSize: '24px', color: '#9ca3af' }}>↓</div>}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div style={{ background: 'white', border: '2px solid #f3f4f6', borderRadius: '12px', padding: '25px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', marginBottom: '20px' }}>🧭 Turn-by-Turn Navigation</h3>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ width: '50px', height: '50px', border: '4px solid #f3f4f6', borderTopColor: '#667eea', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 15px' }} />
                <p style={{ color: '#6b7280' }}>Fetching route instructions...</p>
              </div>
            ) : instructions.length > 0 ? (
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {instructions.map((instruction, idx) => (
                  <div key={idx} style={{ display: 'flex', gap: '15px', padding: '15px', background: idx % 2 === 0 ? '#f9fafb' : 'white', borderRadius: '8px', marginBottom: '10px' }}>
                    <div style={{ minWidth: '40px', height: '40px', background: '#667eea', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 600 }}>{idx + 1}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '15px', color: '#1f2937', fontWeight: 500 }}>{instruction.text}</div>
                      {instruction.distance && <div style={{ fontSize: '13px', color: '#6b7280' }}>📏 {instruction.distance}</div>}
                      {instruction.time && <div style={{ fontSize: '13px', color: '#6b7280' }}>⏱️ {instruction.time}</div>}
                    </div>
                    <div style={{ fontSize: '24px' }}>{getDirectionIcon(instruction.sign)}</div>
                  </div>
                ))}
              </div>
            ) : directionsError ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>⚠️</div>
                <p style={{ color: '#991b1b', fontWeight: 600, marginBottom: '8px' }}>Turn-by-turn navigation unavailable</p>
                <p style={{ color: '#6b7280', fontSize: '14px' }}>{directionsError}</p>
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>🗺️</div>
                <p>No instructions available for this route.</p>
              </div>
            )}
          </div>
        </div>

        <div style={{ borderTop: '2px solid #f3f4f6', padding: '20px 30px', background: '#f9fafb', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: '13px', color: '#6b7280' }}>💡 Based on optimized routing algorithms</div>
          <button onClick={onClose} style={{ padding: '12px 30px', background: '#667eea', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 600 }}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default RouteAnalysisModal;
